import styled from 'styled-components/macro';

import { input } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Label = styled.label`
  cursor: pointer;
  display: flex;
  margin: 10px 0 15px;
  overflow: hidden;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Text = styled.span`
  ${input}

  align-items: center;
  display: flex;
  position: relative;

  ${({ theme }: IWithThemeProps) => `
   color: ${theme.bottomForegroundPrimary};
  `}

  &:before {
    background-color: transparent;
    border-radius: 100%;
    content: '';
    display: inline-block;
    flex: 0 0 auto;
    height: 22px;
    margin: 0 10px 0 0;
    transition-property: background-color, box-shadow;
    transition-timing-function: ease;
    vertical-align: bottom;
    width: 22px;

    ${({ theme }: IWithThemeProps) => `
      border: 1px solid ${theme.bottomForegroundActionPrimary};
      transition-duration: ${theme.transitionDurationPrimary};
    `}
  }
`;

export const Input = styled.input`
  left: -9999px;
  position: absolute;

  ${({ theme }: IWithThemeProps) => `
    &:focus + ${Text} {
      &:before {
        border-color: ${theme.bottomForegroundActionPrimary};
      }
    }

    &:checked + ${Text} {
      &:before {
        background-color: ${theme.bottomForegroundActionPrimary};
        box-shadow: 0 0 0 5px #fff inset;
      }
    }
  `}
`;
